<mat-card>
    {{'efCategoryFees' | translate}}
</mat-card>


<div align="end" class="row" style="padding:10px 10px 10px 10px;">
    <span class="spacer"></span>


    <button mat-raised-button color="primary" (click)="setAsDefault()" [disabled]="selectedCategory == 0">
        <mat-icon>done</mat-icon>
        {{'setAsDefault' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button color="primary" (click)="saveForm()" [disabled]="!catecoryFeesForm.valid">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>


</div>

<mat-card>
    <form [formGroup]="catecoryFeesForm" #formDir="ngForm">
        <br>
        <mat-grid-list cols="5" rowHeight="50px">


            <mat-grid-tile colspan="1">
                <mat-form-field appearance="standard" style="margin-right: 5px;">
                    <mat-label>{{'userCatg' | translate}}</mat-label>
                    <mat-select formControlName="catgId" (selectionChange)="catgSelectChange()">
                        <mat-option *ngFor="let item of categories" [value]="item.id"> {{item.name}} </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile colspan="1">
                <button mat-raised-button color="primary" (click)="addNewCategory()">
                    <mat-icon>done</mat-icon>
                    {{'addNewCategory' | translate}}
                </button>
            </mat-grid-tile>

        </mat-grid-list>

        <div formArrayName="feesAmounts">
            <div *ngFor="let item of getFeesAmountControls();let i = index" [formGroupName]="i">

                <mat-grid-list cols="5" rowHeight="70px">

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'fromAmount' | translate}}</mat-label>
                            <input matInput formControlName="fromAmount" type="number">

                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'toAmount' | translate}}</mat-label>
                            <input matInput formControlName="toAmount" type="number">

                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'commission' | translate}}</mat-label>
                            <input matInput formControlName="totalFees" type="number">
                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'appfees' | translate}}</mat-label>
                            <input matInput formControlName="appFees" type="number">

                        </mat-form-field>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <mat-form-field appearance="standard">
                            <mat-label>{{'merchantFees' | translate}}</mat-label>
                            <input matInput formControlName="merchantFees" type="number">
                        </mat-form-field>
                    </mat-grid-tile>

                </mat-grid-list>

                <!-- <mat-grid-list cols="5" rowHeight="70px">

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'fromAmount' | translate}}</mat-label>
                    <input matInput formControlName="fromAmount2" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.fromAmount2.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'toAmount' | translate}}</mat-label>
                    <input matInput formControlName="toAmount2" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.toAmount2.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'commission' | translate}}</mat-label>
                    <input matInput formControlName="commission2" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.commission2.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'appfees' | translate}}</mat-label>
                    <input matInput formControlName="appfees2" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.appfees2.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'merchantFees' | translate}}</mat-label>
                    <input matInput formControlName="merchantFees2" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.merchantFees2.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="5" rowHeight="70px">

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'fromAmount' | translate}}</mat-label>
                    <input matInput formControlName="fromAmount3" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.fromAmount3.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'toAmount' | translate}}</mat-label>
                    <input matInput formControlName="toAmount3" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.toAmount3.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'commission' | translate}}</mat-label>
                    <input matInput formControlName="commission3" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.commission3.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'appfees' | translate}}</mat-label>
                    <input matInput formControlName="appfees3" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.appfees3.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'merchantFees' | translate}}</mat-label>
                    <input matInput formControlName="merchantFees3" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.merchantFees3.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="5" rowHeight="70px">

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'fromAmount' | translate}}</mat-label>
                    <input matInput formControlName="fromAmount4" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.fromAmount4.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'toAmount' | translate}}</mat-label>
                    <input matInput formControlName="toAmount4" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.toAmount4.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'commission' | translate}}</mat-label>
                    <input matInput formControlName="commission4" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.commission4.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'appfees' | translate}}</mat-label>
                    <input matInput formControlName="appfees4" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.appfees4.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'merchantFees' | translate}}</mat-label>
                    <input matInput formControlName="merchantFees4" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.merchantFees4.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="5" rowHeight="70px">

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'fromAmount' | translate}}</mat-label>
                    <input matInput formControlName="fromAmount5" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.fromAmount5.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'toAmount' | translate}}</mat-label>
                    <input matInput formControlName="toAmount5" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.toAmount5.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'commission' | translate}}</mat-label>
                    <input matInput formControlName="commission5" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.commission5.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'appfees' | translate}}</mat-label>
                    <input matInput formControlName="appfees5" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.appfees5.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
                <mat-form-field appearance="standard">
                    <mat-label>{{'merchantFees' | translate}}</mat-label>
                    <input matInput formControlName="merchantFees5" type="number">
                    <mat-error *ngIf="catecoryFeesForm.controls.merchantFees5.invalid">{{'requiredField' |
                        translate}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list> -->
            </div>
        </div>

    </form>
</mat-card>



<ng-template #ModalCategory>

    <h1 mat-dialog-title>{{!updateMode ? ('create' | translate) : ('update' | translate) }}</h1>
    <div mat-dialog-content>


        <mat-form-field appearance="standard">
            <mat-label>{{'name' | translate}}</mat-label>
            <input matInput [(ngModel)]="categoryName">
        </mat-form-field>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" (click)="saveCategory()">{{'submit' | translate}}</button>
    </div>

</ng-template>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>